import SimplexNoise from './vendor/SimplexNoise';
import $ from 'jquery';
import * as THREE from 'three';
import {$win} from '../common';


export default function Particles(canvasSelector) {
    'use strict';

    let _this = this;
    let options = new function() {
        this.size = 700; // particles spread in the plane
        this.sizeH = 2100; // particles spread in height
        this.noiseModifer = 0.95;
        this.noiseStrength = 0.15;
        this.velocitySlowing = 0.99;
        this.clearColor = 0x304ffe;
        this.particlesCount = 15000;
        this.particlesColor = 0x222222;
        this.particlesSize = 11.0;
    };
    let camera, scene, renderer;
    let $container;
    let positions, alphas, velocity;
    const noise = new SimplexNoise();



    function _alphaFromPosition(ny) {
        let opacity;
        if (ny < 0.2 || ny > 0.8) {
            opacity = Math.abs(Math.abs(ny - 0.5) - 0.5) * 5;
        } else {
            opacity = 1;
        }
        return opacity;
    }
    function _generateTexture() {
        let canvas = document.createElement('canvas');
        canvas.width = 2048;
        canvas.height = 2048;
        let ctx = canvas.getContext('2d');
        ctx.beginPath();
        ctx.arc(1024,1024,1024,0,2*Math.PI);
        ctx.fill();

        let texture = new THREE.Texture(canvas);
        texture.needsUpdate = true;
        return texture;
    }

    function _fillParticleData(newOpts) {
        if (newOpts) {
            options = newOpts;
        }
        let size2 = options.size / 2;
        let sizeH2 = options.sizeH / 2;
        for (let i = 0; i < positions.length; i += 3) {
            velocity[i] = Math.random() - 0.5;
            velocity[i + 2] = Math.random() - 0.5;
            // positions
            let angle = 2 * Math.PI * Math.random();
            let u = Math.random() + Math.random();
            let radius = u > 1 ? 2 - u : u;
            positions[i] = radius * Math.cos(angle) * size2;
            positions[i + 1] = Math.random() * options.sizeH - sizeH2;
            positions[i + 2] = radius * Math.sin(angle) * size2;
            // alphas
            let ny = positions[i + 1] / options.sizeH + 0.5;
            alphas[i / 3] = _alphaFromPosition(ny);
        }
    }

    function _initParticles() {
        positions = new Float32Array(options.particlesCount * 3);
        alphas = new Float32Array(options.particlesCount);
        velocity = new Float32Array(options.particlesCount * 3);

        _fillParticleData();
        _animateStreamInit();

        let geometry = new THREE.BufferGeometry();
        geometry.addAttribute('position', new THREE.BufferAttribute(positions, 3).setDynamic(true));
        geometry.addAttribute('alpha', new THREE.BufferAttribute(alphas, 1).setDynamic(true));
        geometry.computeBoundingSphere();
        //

        // uniforms
        let uniforms = {
            size: {value: options.particlesSize},
            color: {value: new THREE.Color(options.particlesColor)},
            texture: {value: _generateTexture()}
        };
        // point cloud material
        let material = new THREE.ShaderMaterial({
            uniforms: uniforms,
            vertexShader: document.getElementById('vertexshader').textContent,
            fragmentShader: document.getElementById('fragmentshader').textContent,
            //blending: THREE.SubtractiveBlending,
            depthTest: false,
            depthWrite: false,
            //alphaTest: 0.5,
            transparent: true,
        });

        _this.particleCloud = new THREE.Points(geometry, material);
        scene.add(_this.particleCloud);
    }

    function _animateStream() {
        let time = Date.now();

        let size2 = options.size / 2;
        let sizeH2 = options.sizeH / 2;
        for (let i = 0; i < positions.length; i += 3) {
            velocity[i] *= options.velocitySlowing;
            velocity[i + 1] *= options.velocitySlowing;
            velocity[i + 2] *= options.velocitySlowing;
            // noise force
            let nx = positions[i] / options.size + 0.5;
            let ny = positions[i + 1] / options.sizeH + 0.5;
            let nz = positions[i + 2] / options.size + 0.5;
            velocity[i] += noise.noise3d(nx / options.noiseModifer, ny / options.noiseModifer, time * 0.05 / options.noiseModifer) * options.noiseStrength * (Math.random() + 0.5);
            velocity[i + 1] += noise.noise3d(ny / options.noiseModifer, nz / options.noiseModifer, time * 0.05 / options.noiseModifer) * options.noiseStrength;
            velocity[i + 2] += noise.noise3d(nz / options.noiseModifer, nx / options.noiseModifer, time * 0.05 / options.noiseModifer) * options.noiseStrength * (Math.random() + 0.5);
            // velocity[i] += (Math.random() - 0.5) * 0.1;
            // velocity[i + 2] += (Math.random() - 0.5) * 0.1;

            // gravity force
            let radiusScale = Math.pow(positions[i] / options.size, 2) + Math.pow(positions[i + 2] / options.size, 2);
            radiusScale = Math.pow(radiusScale, 2) / 200;
            velocity[i] += -positions[i] / size2 * radiusScale;
            velocity[i + 2] += -positions[i + 2] / size2 * radiusScale;
            //if (i === 0) { console.log(positions[i], positions[i + 1], positions[i + 2], radiusScale) }

            // limit velocity
            // velocity[i] = Math.min(2, Math.max(-2, velocity[i]));
            // velocity[i + 2] = Math.min(2, Math.max(-2, velocity[i + 2]));

            // update positions
            positions[i] += velocity[i];
            positions[i + 1] += velocity[i + 1] * 0.5 - 1;
            positions[i + 2] += velocity[i + 2];

            // recalc positions
            if (positions[i + 1] < -1 * sizeH2) {
                let angle = 2 * Math.PI * Math.random();
                let u = Math.random() + Math.random();
                let radius = u > 1 ? 2 - u : u;
                positions[i] = radius * Math.cos(angle) * size2;
                positions[i + 1] = sizeH2;
                positions[i + 2] = radius * Math.sin(angle) * size2;
                velocity[i] = Math.random() - 0.5;
                velocity[i + 2] = Math.random() - 0.5;
            }
            // alphas
            alphas[i / 3] = _alphaFromPosition(ny);
        }
        _this.particleCloud.geometry.attributes.position.needsUpdate = true;
        _this.particleCloud.geometry.attributes.alpha.needsUpdate = true;

        _this.particleCloud.rotation.y += 0.001;
    }

    // основан на animateStream, но без движения по y
    function _animateStreamInit() {
        let time = Date.now();
        let size2 = options.size / 2;
        let count = 50;
        for (let countI = 1; countI <= count; countI ++) {
            for (let i = 0; i < positions.length; i += 3) {
                velocity[i] *= options.velocitySlowing;
                velocity[i + 2] *= options.velocitySlowing;
                // noise force
                let nx = positions[i] / options.size + 0.5;
                let ny = positions[i + 1] / options.sizeH + 0.5;
                let nz = positions[i + 2] / options.size + 0.5;
                velocity[i] += noise.noise3d(nx / options.noiseModifer, ny / options.noiseModifer, time * 0.05 / options.noiseModifer) * options.noiseStrength * (Math.random() + 0.5);
                velocity[i + 2] += noise.noise3d(nz / options.noiseModifer, nx / options.noiseModifer, time * 0.05 / options.noiseModifer) * options.noiseStrength * (Math.random() + 0.5);

                // gravity force
                let radiusScale = Math.pow(positions[i] / options.size, 2) + Math.pow(positions[i + 2] / options.size, 2);
                radiusScale = Math.pow(radiusScale, 2) / 200;
                velocity[i] += -positions[i] / size2 * radiusScale;
                velocity[i + 2] += -positions[i + 2] / size2 * radiusScale;

                // update positions
                positions[i] += velocity[i];
                positions[i + 2] += velocity[i + 2];

                // alphas
                if (countI === count) {
                    alphas[i / 3] = _alphaFromPosition(ny);
                }
            }
        }
    }

    this.getPositions = function () {
        return positions;
    };




    _initBase();
    _initParticles();

    function _initBase() {
        $container = $(canvasSelector);
        camera = new THREE.PerspectiveCamera(60, $container.outerWidth() / $container.outerHeight(), 5, 15000);
        camera.position.z = 1500;
        camera.position.x = -0.4 * $container.outerWidth();
        scene = new THREE.Scene();
        scene.fog = new THREE.Fog(options.clearColor, 1000, 10000);
        //
        renderer = new THREE.WebGLRenderer({antialias: true, logarithmicDepthBuffer: true});
        renderer.setClearColor(options.clearColor);
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize($container.outerWidth(), $container.outerHeight());
        $container[0].appendChild(renderer.domElement);
        //
        $win.on('resize fullpage_resized', function () {
            camera.aspect = $container.outerWidth() / $container.outerHeight();
            camera.updateProjectionMatrix();
            renderer.setSize($container.outerWidth(), $container.outerHeight());
        }, false);
    }

    let animating = 0;
    this.play = function () {
        // cant start if already playing
        if (animating) {
            return;
        }
        animating = true;
        _animate();
    };
    this.stop = function () {
        window.cancelAnimationFrame(animating);
        animating = null;
    };
    function _animate() {
        if (!animating) {
            return;
        }
        _animateStream();
        renderer.render(scene, camera);
        animating = window.requestAnimationFrame(_animate);
    }
}




// WEBPACK FOOTER //
// ./scripts/three-particles.js